<template lang="pug">
  .container#container
    container-main(v-if="isLogin && !$route.meta.withOutMenu")
      router-view
      //- footer.container-copyright Copyright © 2017, 广州市思力智慧互联网科技有限公司
    router-view(v-else)
</template>

<script>
import { homeUrl, env } from './utils/config';
export default {
  computed: {
    isLogin () {
      return this.$store.getters.isLogin;
    },
  },
  methods: {
    logout () {
      this.$store.dispatch('LOGOUT');
    },
  },
  created () {
    this.$store.watch(({ loginStatus }) => {
      if (loginStatus === null) {
        if (env === 'development') {
          this.$router.replace({ path: '/login' });
        } else {
          location.replace(homeUrl);
        }
      }
    });
  },
  beforeDestroy () {

  }
};
</script>

<style lang="less">
@import "assets/variables";
@import "./assets/mixin";
@import "./assets/general";
@import "assets/element-RFCommunity";
@import "./assets/icons.less";

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;

  font-family: "微软雅黑", sans-serif;

  color: @font-color-black;
}
body {
  overflow-x: hidden;
}

.container {
  height: 100%;
}

.container-content {
  display: flex;
  box-sizing: border-box;
  width: auto;
  height: e("calc(100% - 70px)");
  min-width: 800px;
}
.container-pagination {
  margin-top: 20px;
}

.container-main {
  width: 100%;
  height: 100%;
}

.container-menu {
  overflow: auto;

  width: 200px;
  min-width: 200px;
  background: #2b3245;
}

.container-router-view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow: auto;
}

.container-padding {
  padding: 0 20px;
}

.container-copyright {
  margin-top: 1em;
  margin-bottom: 1em;
  text-align: center;
  font-size: 12px;
  color: #999999;
}

h1 {
  margin: 0;
  color: #eff2f7;
  font-size: @font-size-big;
}

h2 {
  margin: 0 0 10px 0;
}

.toolbar,
.dialog-footer {
  button {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
  .fr {
    button {
      margin-left: 20px;
      margin-right: 0;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
.row-toolbox,
.dialog-footer {
  .align-center;
}
.search-input {
  width: 300px;
  line-height: initial;
}
.toolbar {
  margin-bottom: 10px;
}

.uploadList {
  list-style: none;
  padding: 0;
  margin: 0;
}
.imgUploadList {
  list-style: none;
  padding: 0;
  margin: 0;

li {
    display: inline-block;
    position: relative;

    button {
      position: absolute;
      right: 0;
      display: none;
    }

    &:hover button {
      display: block;
    }

    .image {
      display: inline-block;
      height: 100px;
      width: 100px;

      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
.imgView {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}

.small {
  font-size: 12px;
}

.dialog-footer {
  text-align: center;
}

.container-filters {
  width: 100%;
}

.service-info-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .service-icon-container {
    width: 100px;
    text-align: right;
  }

  .service-info {
    flex: 3;
    padding-left: 20px;
  }

  .el-rate {
    height: 1em;
    font-size: 12px;

    .el-rate__icon {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue